module.exports = __webpack_public_path__ + "img/health-care-home.63aebc4f.jpg";